import { supabase } from "./supabase";
import { api } from "./api";
import { sanitizeLoginNext } from "./loginCopy";

const OAUTH_NEXT_KEY = "ln_oauth_next_v1";

export function storeOAuthReturnTo(path) {
  localStorage.setItem(OAUTH_NEXT_KEY, sanitizeLoginNext(path));
}

export function consumeOAuthReturnTo() {
  const path = localStorage.getItem(OAUTH_NEXT_KEY);
  localStorage.removeItem(OAUTH_NEXT_KEY);
  return sanitizeLoginNext(path);
}

function dancerIdFromStorage() {
  try {
    const raw = localStorage.getItem("ln_identity_v1");
    const ident = raw ? JSON.parse(raw) : null;
    return ident?.dancer_id || null;
  } catch {
    return null;
  }
}

export async function signInWithGoogle(returnTo) {
  const path = returnTo || `${window.location.pathname}${window.location.search}`;
  storeOAuthReturnTo(path);
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: `${window.location.origin}/auth/callback`,
    },
  });
  if (error) throw error;
}

export async function signInWithApple(returnTo) {
  const path = returnTo || `${window.location.pathname}${window.location.search}`;
  storeOAuthReturnTo(path);
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "apple",
    options: {
      redirectTo: `${window.location.origin}/auth/callback`,
    },
  });
  if (error) throw error;
}

export async function requestPhoneOtp(phone) {
  const { error } = await supabase.auth.signInWithOtp({ phone });
  if (error) throw error;
}

export async function verifyPhoneOtp(phone, code) {
  const { data, error } = await supabase.auth.verifyOtp({
    phone,
    token: code,
    type: "sms",
  });
  if (error) throw error;
  return exchangeSupabaseSession(data.session);
}

export async function exchangeSupabaseSession(session) {
  if (!session?.access_token) throw new Error("No session.");
  const guestDancerId = dancerIdFromStorage();
  const r = await api.post("/auth/supabase", {
    access_token: session.access_token,
    dancer_id: guestDancerId,
    guest_dancer_id: guestDancerId,
  });
  return r.data;
}

/** After OAuth redirect: exchange for app JWT unless returning to admin. */
export async function completeOAuthIfPresent({ exchange = true } = {}) {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  if (!data.session) return null;
  if (!exchange) return { session: data.session };
  const result = await exchangeSupabaseSession(data.session);
  await signOutSupabase();
  return { data: result };
}

export async function signOutSupabase() {
  try {
    await supabase.auth.signOut();
  } catch {
    /* ignore if already signed out */
  }
}

export function formatAuthError(err) {
  const msg = err?.message || "";
  if (msg.includes("User cancelled") || msg.includes("popup")) {
    return "Sign-in cancelled.";
  }
  if (msg.includes("invalid phone")) {
    return "That phone number doesn't look valid. Include country code (e.g. +49…).";
  }
  if (msg.includes("Invalid OTP") || msg.includes("invalid verification")) {
    return "Wrong code. Try again.";
  }
  if (msg.includes("expired")) {
    return "Code expired. Request a new one.";
  }
  if (msg.includes("rate limit") || msg.includes("too many")) {
    return "Too many attempts. Wait a moment and try again.";
  }
  return msg || "Sign-in failed. Try again.";
}
